import { Box, Typography } from "@mui/material";
import type { HelpMenuItemProps } from "@types_def/components/helpMenuItem";
import { HelpMenuItemType } from "@types_def/components/helpMenuItem";
import { useRef } from "react";

import HelpMenuItem from "./HelpMenuItem";

const helpMenuItems: HelpMenuItemProps[] = [
  {
    method: "Nous contacter par téléphone :",
    type: HelpMenuItemType.PHONE,
    contactInfo: "09 84 52 42 69",
    responseTime: "Ouvert du lundi au vendredi de 8h00 à 18h00.",
  },
  {
    method: "Nous contacter par e-mail :",
    type: HelpMenuItemType.EMAIL,
    contactInfo: "contact@alb-mobility.com",
    responseTime: "Réponse garantie sous 24-48h00.",
  },
  {
    method: "Nous contacter par chat :",
    type: HelpMenuItemType.CHAT,
    contactInfo: "Lancer une conversation",
    responseTime: "Ouvert du lundi au vendredi de 8h00 à 18h00.",
  },
];

function Help() {
  const chatItemRef = useRef<HTMLIFrameElement>(null);
  const helpMenuItemRef = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={helpMenuItemRef}
      sx={{
        height: "calc(100vh - 75px)",
        position: "relative",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          Besoin d’aide ?
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            width: "52.5%",
            color: "var(--text-color-one)",
          }}
        >
          {/* Optional: Add description here */}
        </Typography>
      </Box>

      {/* Help menu */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          px: 2,
        }}
      >
        {helpMenuItems.map((item, index) => (
          <HelpMenuItem key={index} {...item} />
        ))}
      </Box>

      {/* Zendesk chat iframe (if needed) */}
      <iframe
        ref={chatItemRef}
        className="chat"
        style={{
          border: 0,
          position: "absolute",
          right: "1rem",
          bottom: "2rem",
          width: "400px",
          height: "600px",
        }}
        title="Zendesk Chat"
      />
    </Box>
  );
}

export default Help;
